class ShiftDayService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  get(params) {
    return this.apiService.get('/api/v1/avg/shift-days', params);
  }

  getOne(params) {
    return this.apiService.get('/api/v1/avg/shift-day', params);
  }

  getById(id) {
    return this.apiService.get(`/api/v1/avg/shift-day/${id}`);
  }

  remove(params) {
    return this.apiService.delete('/api/v1/avg/shift-day', params);
  }

  save(params) {
    return this.apiService.post('/api/v1/avg/shift-day', params);
  }

  createPDF(id) {
    return this.apiService.post(`/api/v1/avg/shift-day/${id}/pdf`, {});
  }
}

export default ShiftDayService;
